export default __webpack_public_path__ + "static/brand-logo-white-34d47545224402c04319d40a6d4afe07.svg";